export const columnList = [
  { type: 'id', custom: { width: '60' } },
  { type: 'subject' },
  { type: 'send_count', custom: { width: '100' } },
  { type: 'open_info', custom: { width: '110' } },
  { type: 'click_info', custom: { width: '90' } },
  { type: 'status', custom: { width: '100' } },
  { type: 'publish_at_hkt', custom: { width: '150' } },
]